import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CookieLawService } from './cookie-law.service';
import { Cookie, CookieExpiration, CookieFiltered, CookieProvider, CookieType } from './cookie-law.entity';

@Component({
  selector: 'sacyr-cookie-law',
  templateUrl: './cookie-law.component.html',
  styleUrls: ['./cookie-law.component.scss']
})
export class CokieLawComponent implements OnInit {
  @Output() outStoreGoogleCookies: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _IS_ACCUAMA_CLASSIC = false;
  private _COOKIE_SHOULD_SHOW = 'moove_gdpr_popup';
  private _cookies: Cookie[] = [];
  private _cookiesTypes: CookieType[] = [
    CookieType.ANALYTICS, CookieType.TECNOLOGICAL
  ];

  _cookiesFiltered: CookieFiltered[] = [];
  cookiesDiffer;

  PROVIDER_SELF = CookieProvider.SELF;
  COOKIES_ACCEPTED = false;
  COOKIES_SHOW_DETAIL = false;
  TYPE_SELECTED = this._cookiesTypes[0];

  increment = 0;

  constructor(
    private cookieService: CookieLawService
  ) { }

  async ngOnInit(): Promise<void> {
    this.COOKIES_ACCEPTED = this.hasAcceptedCookies();
    await this.fillCookiesList();
    this.getCookies();
  }

  private fillCookiesList() {
    this._cookies = [];

    this._cookies.push(new Cookie(
      this._COOKIE_SHOULD_SHOW,
      CookieProvider.SELF,
      CookieExpiration.YEAR,
      'Usamos esta cookie para mantener la preferencia de cookies establecida por el usuario',
      CookieType.TECNOLOGICAL
    ));

    this._cookies.push(new Cookie(
      'PHPSESSID',
      CookieProvider.SELF,
      CookieExpiration.SESSION,
      'La cookie PHPSESSID es nativa de PHP y permite a los sitios web almacenar datos de estado serializados. En el sitio web se utiliza para establecer una sesión de usuario y para pasar los datos de estado a través de una cookie temporal, que se conoce comúnmente como una cookie de sesión. Estas Cookies solo permanecerán en su equipo hasta que cierre el navegador.',
      CookieType.TECNOLOGICAL
    ));

    if (this._IS_ACCUAMA_CLASSIC) {
      this._cookies.push(new Cookie(
        'tramitesonline',
        CookieProvider.SELF,
        CookieExpiration.SESSION,
        '',
        CookieType.TECNOLOGICAL
      ));
    }

    // COOKIES: GOOGLE
    this._cookies.push(new Cookie(
      '_gat',
      CookieProvider.GOOGLE,
      CookieExpiration.SESSION,
      'Se utiliza con fines estadísticos y analíticos para aumentar el rendimiento de nuestros servicios',
      CookieType.ANALYTICS
    ));

    this._cookies.push(new Cookie(
      '_gid',
      CookieProvider.GOOGLE,
      CookieExpiration.SESSION,
      'Se utiliza para almacenar y actualizar un valor único para cada página visitada',
      CookieType.ANALYTICS
    ));

    this._cookies.push(new Cookie(
      '_ga',
      CookieProvider.GOOGLE,
      CookieExpiration.SESSION,
      'Se utiliza con fines estadísticos y analíticos para aumentar el rendimiento de nuestros servicios',
      CookieType.ANALYTICS
    ));

    this.fillCookiesListByType();
  }

  private fillCookiesListByType() {
    this._cookiesTypes.map(type => {
      this._cookiesFiltered.push({ type: type, cookies: this.filterCookiesList(type) });
    });
  }

  private hasAcceptedCookies() {
    return this.isNullOrEmpty(this.cookieService.get(this._COOKIE_SHOULD_SHOW)) ? false : true;
  }

  private setCookies() {
    try {
      this._cookiesFiltered.map(cf => {
        cf.cookies.map(cookie => {
          if (cookie.name === this._COOKIE_SHOULD_SHOW) {
            cookie.value = this.getCookiesAsJSON();
          }
          this.cookieService.set(cookie.name, cookie.value, cookie.checked, cookie.options)
        });
      });
      this.COOKIES_ACCEPTED = true;
    } catch (error) {
      console.error(error);
    }
  }

  private getCookies() {
    const cookieMain = this.cookieService.get(this._COOKIE_SHOULD_SHOW);
    if (cookieMain) {
      let storeGoogleCookies = false;
      const json: any[] = JSON.parse(cookieMain);
      this._cookiesFiltered.forEach(cf => {
        cf.cookies.forEach(cookie => {
          cookie.checked = json.find(jc => jc.name === cookie.name).checked;
          if (cookie.provider === CookieProvider.GOOGLE) {
            storeGoogleCookies = cookie.checked;
          }
        })
      });

      this.outStoreGoogleCookies.emit(storeGoogleCookies);

      setTimeout(() => {
        this.setCookies();
      }, 10 * 1000);
    }
  }

  private getCookiesAsJSON() {
    let json = '[';
    this._cookiesFiltered.map(cf => {
      cf.cookies.map(cookie => {
        json += `{"name":"${cookie.name}","checked":${cookie.checked}},`;
      })
    });
    json = json.substring(0, json.length - 1);
    json += ']';
    return JSON.stringify(JSON.parse(json));
  }

  private isNullOrEmpty(value: string) {
    return value === null || value.trim() === '';
  }

  disableCheck(cookies: Cookie[]) {
    return cookies.some(cookie => {
      switch (cookie.provider) {
        case CookieProvider.SELF:
          return true;
        case CookieProvider.GOOGLE:
        case CookieProvider.THIRD:
        default:
          return false;
      }
    });
  }

  onTypeSelected(type: CookieType) {
    this.TYPE_SELECTED = type;
  }

  filterCookiesList(type: CookieType = null, provider: CookieProvider = null) {
    return this._cookies.filter(cookie =>
      cookie.type === type || cookie.provider === provider
    );
  }

  hasCookiesChecked(type: CookieType) {
    return this.filterCookiesList(type).some(cookie => cookie.checked);
  }

  onCheckChecked(type: CookieType) {
    const cf = this._cookiesFiltered.find(cf => cf.type === type);
    if (cf !== null) {
      cf.cookies.forEach(cookie => { cookie.checked = !cookie.checked });
    }
  }

  onCookiesAccepted() {
    this.setCookies();
  }

  // MODAL

  _showModalPoliticaCookies = false;

  showModal() {
    return this._showModalPoliticaCookies;
  }

  closeModal() {
    this._showModalPoliticaCookies = false;
  }
}
